import { ApiService } from '@/common/api.service';
import { normalizeCompany } from '@/common/companies';

// const companies = [
//   'КЦМ АД',
//   'КЦМ 2000',
//   'КЦМ Технолоджи ЕООД',
//   'Комплексен индустриален сервиз ЕООД',
//   'Металургремонт 21 ЕООД',
//   'Стопански дейности КЦМ ЕООД',
//   'Стройсервиз ЕООД',
//   'Индустриална зона КЦМ ЕООД',
//   'Лъки Инвест АД',
//   'Върба-Батанци АД',
//   'BLZ Metalikon Ltd',
//   'MCM BV'
// ]

function getCurrentActiveCompany() {
  let output;

  document.cookie.split(';').map(x => {
    const c = x.split('=');
    if (c[0].charAt(0) == ' ') c[0] = c[0].substring(1, c[0].length);
    if (c[0] === 'activeCompany') {
      output = decodeURIComponent(c[1]);
    }
  });

  return normalizeCompany(output);
}

const state = {
  activeCompany: getCurrentActiveCompany()
};

const getters = {
  activeCompany: state => state.activeCompany
};

const actions = {
  selectCompany(context, value) {
    if (!value || value === getCurrentActiveCompany()) {
      context.commit('selectCompany', value);
      return Promise.resolve();
    }

    return ApiService.post('/auth/set-company', {
      company: value
    }).then(() => {
      context.commit('selectCompany', value);
    });
  },
  refreshActiveCompany(context) {
    context.commit('selectCompany', getCurrentActiveCompany());
  }
};

const mutations = {
  selectCompany(state, value) {
    state.activeCompany = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
